import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import * as S from "./styles";
import sort from "../../assets/images/sort.svg";
import sortup from "../../assets/images/sort_up.svg";
import sortdown from "../../assets/images/sort_down.svg";

export const Sort = ({ onClick, field, sortActive }) => {
  const [status, setStatus] = useState("asc");
  useEffect(() => {
    if (field !== sortActive.FieldId) setStatus("");
  }, [field, sortActive]);

  const show = status === "asc" ? sortup : status === "desc" ? sortdown : sort;

  const handleClick = () => {
    switch (status) {
      case "":
        onClick("asc");
        setStatus("asc");
        break;
      case "asc":
        onClick("desc");
        setStatus("desc");
        break;
      case "desc":
        onClick("asc");
        setStatus("asc");
        break;
      default:
        break;
    }
  };

  return (
    <S.Wrapper onClick={handleClick}>
      <img alt="sort" src={show} />
    </S.Wrapper>
  );
};

Sort.propTypes = {
  onClick: PropTypes.func,
  field: PropTypes.string,
  sortActive: PropTypes.object,
};
